import { METHOD_GET, METHOD_POST, METHOD_DELETE } from 'constants/Methods'
import { API_SLA, API_GOOGLE_CALENDAR } from 'constants/ApiUrls'
import { createApi } from 'utils/index'

export const apiGetSlaSetting = () => createApi(API_SLA, METHOD_GET)

export const apiSaveSlaSetting = data => createApi(API_SLA, METHOD_POST, data)

export const apiDeleteSlaSetting = id => createApi(`${API_SLA}/${id}`, METHOD_DELETE)

export const apiGetGoogleHolidays = ({ country, year }) =>
  createApi(`${API_GOOGLE_CALENDAR}/holidays?country=${country}&year=${year}`, METHOD_GET)
